const EieAssetStatus = Object.assign({
  PUBLISHED: { title: 'Published', status: 'published', color: 'success' },
  DELAYED: { title: 'Delayed', status: 'delayed', color: 'orange' },
  CLOSED: { title: 'Closed', status: 'closed', color: 'grey' },
  INSOLVENCY_PROCEEDING: { title: 'Insolvency proceeding', status: 'in_insolvency_proceeding', color: 'error' },
});

Object.freeze(EieAssetStatus);

export default EieAssetStatus;



// WEBPACK FOOTER //
// ./src/enum/eie/EieAssetStatus.js